import { requestWithToken } from "../helper/helper";

const getShortsList = async (pageNo, pageSize, categoryId="") => {
  try {
    const response = await requestWithToken(
      "GET",
      `/admin/reel/list?pageNo=${pageNo}&pageSize=${pageSize}&categoryId=${categoryId}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const deleteReel = async (id) => {
  try {
    const response = await requestWithToken("DELETE", `/admin/reel/${id}`);

    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const createReel = async (payload) => {
  try {
    const response = await requestWithToken("POST", `/admin/reel`, payload);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const fetchReelDetails = async (id) => {
  try {
    const response = await requestWithToken(
      "GET",
      `/admin/reel/detail/${id}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export {
    getShortsList,
    createReel,
    fetchReelDetails,
    deleteReel
};
